import { Navigate, type RouteObject } from 'react-router-dom'
import { lazyImport } from 'shared/lib'
import { OnboardingLayout } from '../layouts/OnboardingLayout/OnboardingLayout'
import { PageLayout } from '../layouts/PageLayout/PageLayout'

const { LoginPage } = lazyImport(() => import('pages/login'), 'LoginPage')

const { SignUpPage } = lazyImport(() => import('pages/sign-up'), 'SignUpPage')

const { ForgotPasswordPage } = lazyImport(
    () => import('pages/forgot-password'),
    'ForgotPasswordPage'
)

const { PasswordRecoveryPage } = lazyImport(
    () => import('pages/password-recovery'),
    'PasswordRecoveryPage'
)

const { VerificationSuccess } = lazyImport(
    () => import('pages/verification-success/ui/Page'),
    'VerificationSuccess'
)

const { TermsOfUse } = lazyImport(
    () => import('pages/terms-of-use'),
    'TermsOfUse'
)

const { PrivacyPolicy } = lazyImport(
    () => import('pages/privacy-policy'),
    'PrivacyPolicy'
)

export const publicRoutes: RouteObject[] = [
    {
        element: <OnboardingLayout />,
        children: [
            {
                path: '/login',
                element: <LoginPage />,
            },
            {
                path: '/sign-up',
                element: <SignUpPage />,
            },
            {
                path: '/forgot-password',
                element: <ForgotPasswordPage />,
            },
            {
                path: '/password-recovery',
                element: <PasswordRecoveryPage />,
            },
            {
                path: '/verification-success',
                element: <VerificationSuccess />,
            },
        ],
    },
    {
        element: <PageLayout />,
        children: [
            {
                path: '/uvjeti-koristenja',
                element: <TermsOfUse />,
            },
            {
                path: '/politika-privatnosti',
                element: <PrivacyPolicy />,
            },
        ],
    },
    {
        path: '*',
        element: <Navigate to="/login" replace />,
    },
]
